import React from 'react'
import {
  entityAccountHowItWorks,
  entityAccountFeatures,
  entityAccountSubscriptions,
} from '../data/EntityAccountData'
import { TabBottom } from './Extra/TabBottom'
import { SubscriptionFeatureList } from './SubscriptionCard/SubscriptionFeatureList'
import { SubscriptionCardSmall } from './SubscriptionCard/SubscriptionCardSmall'

export const EntityAccountTab = () => {
  return (
    <>
      <h2 className='text-[#37A2BA] font-medium sm:font-bold text-base sm:text-2xl lg:text-[32px] pb-4'>
        Entity Account
      </h2>

      <p className='text-[#6E7785] text-xs sm:text-sm lg:text-base font-normal sm:font-bold tracking-wide'>
        We're excited to introduce Entity Accounts—a new feature for law firms
        and chambers. With an Entity Account, firms can bring all their lawyers
        under one umbrella account, manage multiple profiles, improve booking
        efficiency, and provide a unified presence in Legal Utopia's
        marketplace.
      </p>

      <hr className='my-10 sm:my-12' />

      <div className='flex flex-col gap-20 sm:gap-25'>
        <section className='flex flex-col text-left'>
          <h3 className='text-sm sm:text-lg lg:text-2xl font-medium sm:font-bold text-center sm:text-start sm:pb-4'>
            Membership plans and pricing
          </h3>

          <p className='text-[#6E7785] text-xs sm:text-sm lg:text-base text-center sm:text-start pb-6 sm:pb-10'>
            Our flexible packages are designed to meet the demands of smaller
            practices and large chambers/mid-size law firms.
          </p>

          <div className='flex flex-wrap justify-center lg:justify-start items-center gap-x-[26px] gap-y-4'>
            {entityAccountSubscriptions.map((subscription, index) => (
              <SubscriptionCardSmall
                key={subscription.title + index}
                title={subscription.title}
                subTitle={subscription.subTitle}
                amount={subscription.amount}
                vatAddition={subscription.vatAddition}
                occurence={subscription.occurence}
                additionalAmount={subscription.additionalAmount}
                additionalAmountVat={subscription.additionalAmountVat}
                additionalOccurence={subscription.additionalOccurence}
                buttonLabel={subscription.buttonLabel}
                buttonLink={subscription.buttonLink}
              />
            ))}

            <p className='max-w-[350px] pl-3 pt-12 text-[#6E7785] font-normal sm:font-medium tracking-wide text-xs sm:text-sm lg:text-base text-justify'>
              Each profile plan allows law firms or chambers to list up to the
              specified number of lawyer profiles, providing flexibility to grow
              your team's presence. Add-on profiles are available to expand your
              account without needing to switch to a higher plan.
            </p>
          </div>
        </section>

        <section className='flex flex-col gap-15 sm:gap-6'>
          <div className='flex flex-col gap-4 text-center sm:text-left pb-[26px] sm:pb-0'>
            <h4 className='text-sm sm:text-lg lg:text-2xl font-medium sm:font-bold tracking-wide'>
              Key Features
            </h4>
            <p className='text-[#6E7785] text-xs sm:text-sm lg:text-base tracking-wide'>
              Each membership plan is packed with powerful features that help
              you simplify management and maximise visibility on the Legal
              Utopia platform. Here's what you can expect with each package:
            </p>
          </div>

          <div className='flex flex-col gap-[70px] md:gap-8 text-left'>
            {entityAccountFeatures.map((featureList, index) => (
              <SubscriptionFeatureList
                key={featureList.title + index}
                title={featureList.title}
                color='bg-[#F4F4F4]'
                alternateColor={true}
                startColorOdd={true}
                featureList={featureList.features}
              />
            ))}
          </div>
        </section>

        <TabBottom data={entityAccountHowItWorks} className='bg-[#1C7D93]' />
      </div>
    </>
  )
}
